export const contentStyleState = {
    defaultState: {
        contentExtraMargin: 0,
    },
    actions: {
        setContentExtraMargin: (value, state) => ({...state, contentExtraMargin: value}),
        setContentExtraBorder: (value, state) => ({...state, contentExtraBorder: value}),
    },
}
